export default __webpack_public_path__ + "static/media/urban_design.ea0dbf71.svg";